import { useEffect } from "react";
import { auth } from "../firebase";
import { notifyButtonTapToSlackServer } from "../services/functions";

const BUTTON_SELECTOR = "button, [role=\"button\"], input[type=\"button\"], input[type=\"submit\"], input[type=\"reset\"]";

function normalizeLabel(value: string | null | undefined): string {
  const normalized = (value || "").replace(/\s+/g, " ").trim();
  if (!normalized) return "unlabeled_button";
  return normalized.slice(0, 200);
}

function extractButtonLabel(element: Element): string {
  if (element instanceof HTMLInputElement) {
    return normalizeLabel(element.value || element.getAttribute("aria-label"));
  }

  const htmlElement = element as HTMLElement;
  const ariaLabel = htmlElement.getAttribute("aria-label");
  if (ariaLabel && ariaLabel.trim()) return normalizeLabel(ariaLabel);

  const textLabel = (htmlElement.innerText || htmlElement.textContent || "").trim();
  if (textLabel) return normalizeLabel(textLabel);

  return normalizeLabel(htmlElement.getAttribute("title"));
}

export default function ButtonTapSlackNotifier() {
  useEffect(() => {
    const onDocumentClick = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest(BUTTON_SELECTOR);
      if (!button) return;

      const buttonLabel = extractButtonLabel(button);
      const userId = auth.currentUser?.uid || "anonymous";

      void notifyButtonTapToSlackServer({ userId, buttonLabel }).catch((error) => {
        if (process.env.NODE_ENV !== "production") {
          console.warn("[slack] button tap notification failed", error);
        }
      });
    };

    document.addEventListener("click", onDocumentClick, true);
    return () => {
      document.removeEventListener("click", onDocumentClick, true);
    };
  }, []);

  return null;
}
